<template>
  <div class="header" v-bind:class="{ headerBg: this.$route.path !== '/' }">
    <div class="container">
      <div class="header-flex">
<!--        <div class="mobile-menu">-->
<!--          <button v-on:click="show = !show">-->
<!--            <img src="@/assets/img/icon/menu.svg" alt="" />-->
<!--          </button>-->
<!--          <transition name="slide">-->
<!--            <div v-if="show" class="menu_show">-->
<!--              <div class="menu__block_first">-->
<!--                <button-->
<!--                  class="close_menu"-->
<!--                  @click="closeMenu"-->
<!--                  v-bind:class="{-->
<!--                    close_cabinet: this.$route.path.split('/')[1] == 'cabinet'-->
<!--                  }"-->
<!--                >-->
<!--                  <img src="@/assets/img/icon/close.svg" alt="" />-->
<!--                </button>-->
<!--                <div-->
<!--                  class="users_data"-->
<!--                  v-if="this.$route.path.split('/')[1] == 'cabinet'"-->
<!--                >-->
<!--                  <p>{{ profile.firstname }} {{ profile.lastname }}</p>-->
<!--                  &lt;!&ndash; <span>SLT: {{ profile.bonus }}</span> &ndash;&gt;-->
<!--                  <span>{{$t('bonuse')}}: {{ profile.bonus_1c }}</span>-->
<!--                  <span>{{$t('status')}}: {{ profile.bonus_category }}</span>-->
<!--                </div>-->
<!--                <div class="menu__check">-->
<!--                  &lt;!&ndash; <div class="item" @click="showFirst = !showFirst">-->
<!--                    Русский язык-->
<!--                    <img src="@/assets/img/icon/ic-next.svg" alt="" />-->
<!--                  </div> &ndash;&gt;-->
<!--                  <div-->
<!--                    class="item"-->
<!--                    @click="showSecond = !showSecond"-->
<!--                    v-if="this.$route.path.split('/')[1] !== 'cabinet'"-->
<!--                  >-->
<!--                    <img-->
<!--                      src="@/assets/img/icon/ic-address.svg"-->
<!--                      alt=""-->
<!--                      class="ic-address"-->
<!--                    />-->
<!--                    {{ selected.name }}-->
<!--                    <img src="@/assets/img/icon/ic-next.svg" alt="" />-->
<!--                  </div>-->
<!--                </div>-->
<!--                <ul-->
<!--                  class="menu-list"-->
<!--                  v-if="this.$route.path.split('/')[1] !== 'cabinet'"-->
<!--                >-->
<!--                  <li><router-link to="/">{{$t('main')}}</router-link></li>-->
<!--                  <li><router-link to="/about">{{$t('about')}}</router-link></li>-->
<!--                  <li><router-link to="/services">{{$t('our_services')}}</router-link></li>-->
<!--                  <li><router-link to="/guide">{{$t('guide')}}</router-link></li>-->
<!--                </ul>-->
<!--                <ul class="menu-list" v-else>-->
<!--                  <li>-->
<!--                    <router-link to="/cabinet/my-lombard"-->
<!--                      >{{$t('my_pawnshop')}}</router-link-->
<!--                    >-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <router-link to="/cabinet/settings">{{$t('settings')}}</router-link>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <router-link to="/cabinet/bonuses">{{$t('bonuses')}}</router-link>-->
<!--                  </li>-->
<!--                  &lt;!&ndash; <li>-->
<!--                    <router-link to="/cabinet/referral"-->
<!--                      >{{$t('referral')}}</router-link-->
<!--                    >-->
<!--                  </li> &ndash;&gt;-->
<!--                  <li><div class="go_out">{{$t('go_out')}}</div></li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <transition name="slide">-->
<!--                <div v-if="showFirst" class="menu__block_second">-->
<!--                  <div class="menu__block_first">-->
<!--                    <div class="button-flex">-->
<!--                      <button class="back_menu" @click="showFirst = !showFirst">-->
<!--                        <img src="@/assets/img/icon/ic-prev.svg" alt="" />-->
<!--                      </button>-->
<!--                      <button class="close_menu" @click="closeMenu">-->
<!--                        <img src="@/assets/img/icon/close.svg" alt="" />-->
<!--                      </button>-->
<!--                    </div>-->
<!--                    <div class="menu__check">-->
<!--                      <div class="item">-->
<!--                        {{$t('russian_language')}}-->
<!--                        <img src="@/assets/img/icon/ic-check.svg" alt="" />-->
<!--                      </div>-->
<!--                      <div class="item">{{$t('kazakh_language')}}</div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </transition>-->
<!--              <transition name="slide">-->
<!--                <div v-if="showSecond" class="menu__block_second">-->
<!--                  <div class="menu__block_first">-->
<!--                    <div class="button-flex">-->
<!--                      <button-->
<!--                        class="back_menu"-->
<!--                        @click="showSecond = !showSecond"-->
<!--                      >-->
<!--                        <img src="@/assets/img/icon/ic-prev.svg" alt="" />-->
<!--                      </button>-->
<!--                      <button class="close_menu" @click="closeMenu">-->
<!--                        <img src="@/assets/img/icon/close.svg" alt="" />-->
<!--                      </button>-->
<!--                    </div>-->
<!--                    <div class="menu__check">-->
<!--                      <div-->
<!--                        class="item"-->
<!--                        v-for="(city, index) in cities"-->
<!--                        :key="index"-->
<!--                        @click="chooseСity(city, index)"-->
<!--                      >-->
<!--                        {{ city.name }}-->
<!--                        <img-->
<!--                          src="@/assets/img/icon/ic-check.svg"-->
<!--                          alt=""-->
<!--                          v-if="city.name === selected.name"-->
<!--                        />-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </transition>-->
<!--            </div>-->
<!--          </transition>-->
<!--        </div>-->
        <div class="head-1">
          <div class="logo">
            <a href="https://cabinet.seiflombard.kz">
              <img src="@/assets/img/logo.png" alt=""/>
            </a>
          </div>
<!--          <div class="menu">-->
<!--            <ul>-->
<!--              <li><router-link to="/">{{$t('main')}}</router-link></li>-->
<!--              <li><router-link to="/about">{{$t('about')}}</router-link></li>-->
<!--              <li><router-link to="/services">{{$t('our_services')}}</router-link></li>-->
<!--              <li><router-link to="/guide">{{$t('guide')}}</router-link></li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
        <div class="head-2">
<!--          <div class="tel">-->
<!--            <img src="@/assets/img/icon/tel.svg" alt="" />-->
<!--            <a href="tel:87078333555">8 (707) 8 333 555</a>-->
<!--          </div>-->
<!--          <div class="city">-->
<!--            <div class="dropdown" id="dropdown" :class="change()">-->
<!--              <button-->
<!--                class="dropdown-toggle"-->
<!--                type="button"-->
<!--                id="dropdown-toggle-city"-->
<!--                data-toggle="dropdown"-->
<!--              >-->
<!--                <img src="@/assets/img/icon/city.svg" alt="" />-->
<!--                <span>{{ selected.name }}</span>-->
<!--              </button>-->
<!--              <ul-->
<!--                class="dropdown-menu dropdown-menu-right"-->
<!--                role="menu"-->
<!--                aria-labelledby="dropdown-toggle-city"-->
<!--              >-->
<!--                <li-->
<!--                  v-for="(city, index) in cities"-->
<!--                  :key="index"-->
<!--                  class="city-item"-->
<!--                  @click="chooseСity(city, index)"-->
<!--                  :style="[-->
<!--                    city.name === selected.name-->
<!--                      ? {-->
<!--                          'border-radius': '17.5px',-->
<!--                          'background-image':-->
<!--                            'linear-gradient(to bottom, #FAE06D, #F3BE3B)',-->
<!--                          'box-shadow': '0 4px 20px 0 rgba(255, 205, 103, 0.3)',-->
<!--                          width: '90%'-->
<!--                        }-->
<!--                      : { 'object-fit': 'cover' }-->
<!--                  ]"-->
<!--                >-->
<!--                  <span>{{ city.name }}</span>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="language">-->
<!--            <div class="dropdown">-->
<!--              <button-->
<!--                class="dropdown-toggle"-->
<!--                type="button"-->
<!--                id="menu1"-->
<!--                data-toggle="dropdown"-->
<!--              >-->
<!--              <span v-if="selectedLang == 'ru'">Рус</span>-->
<!--                <span v-if="selectedLang == 'kz'">Қаз</span> <span class="caret"></span>-->
<!--              </button>-->
<!--              <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">-->
<!--                <li role="presentation" v-if="selectedLang == 'ru'" @click="selectLang('kz')">-->
<!--                  <a role="menuitem" tabindex="-1" href="#">Қаз</a>-->
<!--                </li>-->
<!--                <li role="presentation" v-if="selectedLang == 'kz'" @click="selectLang('ru')">-->
<!--                  <a role="menuitem" tabindex="-1" href="#">Рус</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          <button-->
<!--            v-if="this.$route.path.split('/')[1] !== 'cabinet'"-->
<!--            class="button-yellow"-->
<!--            @click="publishRouter"-->
<!--          >-->
<!--            <span>{{$t('my')}}</span>&nbsp;{{$t('office')}}-->
<!--          </button>-->
        </div>
      </div>
    </div>
<!--    <div-->
<!--      class="modal-window-city"-->
<!--      v-if="this.$route.path.split('/')[1] !== 'cabinet'"-->
<!--    >-->
<!--      <div id="modal-city" class="modal fade">-->
<!--        <div class="modal-dialog">-->
<!--          <div class="modal-content">-->
<!--            <div class="modal-body">-->
<!--              <div class="title-m">-->
<!--                {{$t('your_town')}}: <span>{{ nearestCity.text }}</span>-->
<!--              </div>-->
<!--              <div class="modal-button">-->
<!--                <button @click="anotherСity(1)">{{$t('no')}}</button>-->
<!--                <button class="yellow" @click="addCity()">{{$t('yes')}}</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div-->
<!--      class="modal-window-applications"-->
<!--      v-if="this.$route.path.split('/')[1] !== 'cabinet'"-->
<!--    >-->
<!--      <div id="modal-applications" class="modal fade">-->
<!--        <div class="modal-dialog">-->
<!--          <div class="modal-content">-->
<!--            <button-->
<!--              type="button"-->
<!--              class="close"-->
<!--              data-dismiss="modal"-->
<!--              aria-hidden="true"-->
<!--            >-->
<!--              <img src="@/assets/img/icon/close.svg" alt="" />-->
<!--            </button>-->
<!--            <div class="modal-body">-->
<!--              <div class="img"><img src="@/assets/img/phone.png" alt="" /></div>-->
<!--              <div class="text">-->
<!--                <div class="title-m">{{$t('text_1')}}</div>-->
<!--                <div class="text-m">-->
<!--                 {{$t('text_2')}}-->
<!--                </div>-->
<!--                <div class="app">-->
<!--                  <a href="https://apps.apple.com/app/id1197151536" target="_blank"-->
<!--                    ><img src="@/assets/img/appStore.svg" alt=""-->
<!--                  /></a>-->
<!--                  <a href="https://play.google.com/store/apps/details?id=mars.lombard" target="_blank"-->
<!--                    ><img src="@/assets/img/googlePlay.svg" alt=""-->
<!--                  /></a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <authorization></authorization>-->
  </div>
</template>

<script>
// import authorization from '@/components/authorization.vue'
// import ClickOutside from 'vue-click-outside'

export default {
  name: 'headerComponent',
  components: {
    // authorization
  },
  data () {
    return {
      closable: false,
      shown: false,
      show: false,
      showFirst: false,
      showSecond: false,
      cities: '',
      currentMidx: null,
      noCity: false,
      infoWindowPos: null,
      infoWinOpen: false,
      nearestCity: '',
      selectedCity: {},
      markers: [],
      class: '',
      selected: '',
      list: false,
      check: false,
      left1: '-777px',
      left2: '678px',
      profile: '',
      selectedLang: this.$auth.getLanguage(),
      lang: []
    }
  },
  mounted: function () {
    this.getMyLocation()
    if (this.noCity === true) {
      $('#dropdown-toggle-city').click()
    }
    var LS_KEY = 'modal-applications'
    if (!localStorage.getItem(LS_KEY)) {
      setTimeout(function () {
        $('#modal-applications').modal('show')
        localStorage.setItem(LS_KEY, '1')
      }, 15000)
    } else {
      if (localStorage.nearestCity == undefined) {
        var nearestCity = { id: 1, name: 'Алматы' }
        localStorage.setItem('nearestCity', JSON.stringify(nearestCity))
      } else {
        this.selected = JSON.parse(localStorage.nearestCity)
      }
    }
  },
  watch: {
    $route (to, from) {
      this.show = false
      // $('#modal-applications').modal('hide');
      // $('#modal-city').modal('hide');
    },
    selectedCity: function () {
      this.getPoints()
    },
    selected: {
      handler: function (after, before) {
        this.$emit('city', after)
      },
      deep: true
    }
  },
  created () {
    this.getСitiesList()
    this.change()
    this.selected = { id: 1, name: 'Алматы' }
    this.profile = JSON.parse(localStorage.getItem('user'))
    // this.checkValue()
    // this.selected = JSON.parse(localStorage.nearestCity)
    // console.log(localStorage.nearestCity)
  },
  methods: {
    selectLang (lng) {
      if (lng === 'ru') {
        this.$auth.setLanguage(lng)
        location.reload()
      } else if (lng === 'kz') {
        this.$auth.setLanguage(lng)
        location.reload()
      }
    },
    setLanguage (lang) {
      this.$auth.setLanguage(lang)
      location.reload()
    },
    publishRouter () {
      if (this.$auth.isLoggedIn()) {
        window.location.replace('/cabinet/my-lombard')
      } else {
        $('#modal-authorization').modal('show')
      }
    },
    change () {
      return this.class
    },
    closeMenu () {
      this.show = false
      this.showFirst = false
      this.showSecond = false
    },
    getNearestCity () {
      this.$axios
        .get('/location/nearest-city?lat=' + this.lat + '&lng=' + this.lng)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
          } else {
            this.nearestCity = $response.data
            this.selectedCity = {
              id: this.nearestCity.id,
              name: this.nearestCity.text
            }
          }
        })
        .catch(e => console.log(e))
    },
    getСitiesList () {
      this.$axios
        .get('/location/cities-list')
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
          } else {
            this.cities = $response.data
            this.selectedCity = {
              id: this.cities[1].id,
              name: this.cities[1].name
            }
          }
        })
        .catch(e => console.log(e))
    },
    getPoints () {
      this.$axios
        .get('/location/filials-by-city?id=' + this.selectedCity.id)
        .then(response => {
          let $response = response.data
          if ($response.code === 0) {
            console.log($response)
            this.loader = false
          } else {
            this.markers = $response.data
            for (var i = 0; i < this.markers.length; i++) {
              var lat = this.markers[i].lat
              var lng = this.markers[i].lng
              this.markers[i].position = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
              }
            }
          }
        })
        .catch(e => console.log(e))
    },

    toggleInfoWindow: function (marker, index) {
      this.infoWindowPos = marker.position
      this.title = marker.title
      this.description = marker.description
      this.schedule = marker.schedule
      this.phones = marker.phones
      if (this.currentMidx == index) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = index
      }
    },
    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.cannotShowPosition
        )
      }
    },
    cannotShowPosition (error) {
      if (!localStorage.nearestCity) {
        var nearestCity = { id: 1, name: 'Алматы' }
        localStorage.setItem('nearestCity', JSON.stringify(nearestCity))

        // localStorage.setItem ('nearestCity', 'Алматы')
        this.noCity = true
      }
    },
    showPosition (position) {
      var self = this
      self.position = position.coords
      self.lat = position.coords.latitude
      self.lng = position.coords.longitude
      this.getNearestCity()
      if (!localStorage.nearestCity) {
        $('#modal-city').modal('show')
        //  $('.dropdown').toggleClass('open')
      }
    },
    addCity () {
      localStorage.setItem('nearestCity', JSON.stringify(this.selectedCity))
      let obj = JSON.parse(localStorage.nearestCity)
      this.selected = obj
      // this.selected = JSON.parse(localStorage.nearestCity)
      $('#modal-city').modal('hide')
    },
    anotherСity (index) {
      if (index === 1) {
        $('.dropdown').on({
          // "shown.bs.dropdown": function(e) { $('.dropdown').removeClass('open') },
          click: function (e) {
            $('.dropdown').removeClass('open')
          },
          'hide.bs.dropdown': function (e) {
            e.preventDefault()
          }
        })
      } else {
        console.log('ok')
      }
      $('#modal-city').modal('hide')
      this.class = 'open'
      this.noCity = true
    },
    chooseСity (city, index) {
      // $(`#${index}`).toggleClass('active')
      this.list = true
      this.selectedCity.name = city.name
      localStorage.setItem('nearestCity', JSON.stringify(city))
      let obj = JSON.parse(localStorage.nearestCity)
      this.selected = obj

      // console.log(localStorage.user)
    }
  }
  // directives: {
  //   ClickOutside
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/headerComponent.vue